import React, { FC } from 'react'
import { Icon } from 'components/Icon'
import { AreaTools } from 'models/editor'
import { useTranslation } from 'react-i18next'
import { useMapEditorContext, MapEditorWizards } from 'context/map-editor-context'
import { Tooltip } from 'components/Tooltip'

export const MobilityReportTool: FC = () => {
  const { t } = useTranslation()
  const [{ areaTool }, mapEditorDispatch] = useMapEditorContext()

  return (
    <button
      data-selected={areaTool === AreaTools.MOBILITY_REPORT_TOOL ? true : undefined}
      onClick={() => {
        mapEditorDispatch.selectTool(AreaTools.MOBILITY_REPORT_TOOL)
        mapEditorDispatch.setWizard(MapEditorWizards.MOBILITY_REPORT_TOOL)
      }}
      aria-label={t('map.tools.mobility_report')}
    >
      <Tooltip label={t(`tooltips.maptools.reporte_movilidad`)} direction="LEFT_CENTER">
        <Icon name="base-station-line" />
      </Tooltip>
    </button>
  )
}

MobilityReportTool.displayName = 'MobilityReportTool'
